(ns teamoesterreich.firebase.storage-provider
  (:require
    [shadow.cljs.modern :refer (js-await)]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.firebase :as fb]
    [teamoesterreich.user-mode.backend :as backend]
    [teamoesterreich.util.log :as log]
    ))


fb/app

(defn rand-str [len]
  (apply str (take len (repeatedly #(char (+ (rand 26) 65))))))

(defn get-download-url-and-type [fst-url cb]
  (when fst-url
    (js-await [user (.getUser ^js config/user-manager)]
      (js-await [response (js/fetch (str backend/BASE_URL "/get-fs-url")
                                    #js{:method  "POST"
                                        :headers (clj->js (merge {:Content-Type "application/json"}
                                                                 (when user {:Authorization (str "Bearer " (.-access_token user))})))
                                        :body    (js/JSON.stringify #js{:fs-path fst-url})})]
        (if (.-ok response)
          (js-await [body (.json response)]
            (cb (into {} (clojure.walk/keywordize-keys (js->clj body))))))))))

(defn get-download-url [fst-url cb]
  (get-download-url-and-type fst-url (fn [{:keys [url]}] (cb url))))



(defn upload [base-path file doc-type cb-fn & [cb-progress]]
  (log/out "upload file to " base-path "file:" file)
  (js-await [user (.getUser ^js config/user-manager)]
    (let [rand-name (rand-str 30)
          path (str base-path rand-name)
          form-data (doto (js/FormData.)
                      (.append "file" file)
                      (.append "fs-path" (str path))
                      (.append "doc-type" (str doc-type)))]
      (js-await [response (js/fetch (str backend/BASE_URL "/upload-doc")
                                    #js{:method  "POST"
                                        :headers (clj->js (merge {}
                                                                 (when user {:Authorization (str "Bearer " (.-access_token user))})))
                                        :body    form-data})]
        (if (.-ok response)
          (cb-fn path))))))


(defn upload-location-image [file userId locationId cb-fn & [cb-progress]]
  (let [base-path (str "locationPicture/" userId "/" locationId "/")]
    (upload base-path file "" cb-fn cb-progress)))


(defn upload-user-image [file userId cb-fn & [cb-progress]]
  (let [base-path (str "profilePictures/")]
    (upload base-path file "" cb-fn cb-progress)))



(defn upload-user-file [file userId type cb-fn & [cb-progress]]
  (when-let [auth (js/firebase.auth)]
    (when-let [user (.-currentUser auth)]
      (when-let [userId (.-uid user)]
        (let [base-path (str "documents/" userId "/")]
          (upload base-path file type cb-fn cb-progress))))))
;
;
;(def fst-store ((g/get js/firebase "storage")))
;
;(defonce STATE_CHANGED (-> js/firebase (g/get "storage") (g/get "TaskEvent") (g/get "STATE_CHANGED")))
;
;(defn rand-str [len]
;  (apply str (take len (repeatedly #(char (+ (rand 26) 65))))))
;
;
;(defn get-metadata [fst-url cb]
;  (when fst-url
;    (log/out "get from store " fst-url)
;    ;;(.then (.getMetadata (.child (.ref fst-store) fst-url)) cb)
;    ))
;
;
;
;(defn upload [base-path file cb-fn & [cb-progress]]
;  (log/out "upload file to " base-path "file:" file)
;  (let [rand-name (rand-str 30)
;        path (str base-path rand-name)
;        upload-task (-> fst-store   ;upload-task (.put (.child (.ref fst-store) path) file)
;                        ((g/get "ref"))
;                        ((g/get "child") path)
;                        ((g/get "put") file))
;        ]
;    ((g/get upload-task "on") STATE_CHANGED
;         (fn [snapshot] ; Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
;           (let [percent (* (/ (g/get snapshot "bytesTransferred") (g/get snapshot "totalBytes")) 100)]
;             (log/out (str "Upload is " percent  "% done") (str (g/get snapshot "state")))
;             (case (str (g/get snapshot "state"))
;               "paused" (log/out (str "Upload is paused"))
;               "running" (do (log/out (str "Upload is running")
;                                      (when cb-progress (cb-progress percent)))))))
;         (fn [error]
;           (case (g/get error "code")
;             "storage/unauthorized" (log/out (str "User unauthorized"))
;             "storage/canceled" (log/out (str "User canceled"))
;             "storage/unknown" (log/out (str "User unknown"))))
;         (fn []
;           (cb-fn path)
;           ;Upload completed successfully, now we can get the download URL
;           ))))
;
;
;(defn upload-location-image [file userId locationId cb-fn & [cb-progress]]
;  (let [base-path (str "/locationPicture/" userId "/" locationId "/")]
;    (upload base-path file cb-fn cb-progress)))
;
;
;(defn upload-user-image [file userId cb-fn & [cb-progress]]
;  (let [base-path (str "/profilePictures/")]
;    (upload base-path file cb-fn cb-progress)))
;
;
;
;(defn upload-user-file [file userId cb-fn & [cb-progress]]
;  (let [base-path (str "/documents/" userId "/")]
;    (upload base-path file cb-fn cb-progress)))
;
;
;
;
;
;
;
